import { Space } from 'antd';
import type { ReactNode } from 'react';

/**
 * 详情页操作按钮吸底条：随滚动粘在视口底部，内容再长也不用滚到末尾找按钮。
 * 依赖外层为文档级滚动（本项目 Content 区无独立滚动容器），用负外边距抵消 Content 的 24px 内边距拉满宽度。
 * 原先 hospital / ops / supplier / system 各有一份逐字节相同的副本（AIR-1.22），收敛到这里。
 */
export function StickyActionBar({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        margin: '16px -24px -24px',
        padding: '10px 24px',
        background: 'var(--hq-color-bg-container, #fff)',
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.08)',
        borderTop: '1px solid var(--hq-color-border-secondary, #eef1f5)'
      }}
    >
      <Space wrap>{children}</Space>
    </div>
  );
}
